import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { IconButton, Step, StepConnector, StepLabel, Stepper, Typography, stepConnectorClasses, styled } from "@mui/material";
import moment from "moment";
import { CrossIcon, StepIconActive, StepIconComplete, StepIconInActive } from "../../assets/images";
import { MuiStack } from "../atoms/stackComponent";
import { NoRowsOverlay } from "./dataGridComponent";
var QontoConnector = styled(StepConnector)(function (_ref) {
    var _a, _b, _c;
    var theme = _ref.theme;
    return _a = {},
        _a["&.".concat(stepConnectorClasses.alternativeLabel)] = {
            left: 'calc(-50% + 32px)',
            right: 'calc(50% + 16px)',
            backgroundColor: "black"
        },
        _a["&.".concat(stepConnectorClasses.active)] = (_b = {},
            _b["& .".concat(stepConnectorClasses.line)] = {
                borderColor: '#52C41A',
                borderWidth: 1,
                borderLeftStyle: 'solid',
                height: '24px'
            },
            _b),
        _a["&.".concat(stepConnectorClasses.completed)] = (_c = {},
            _c["& .".concat(stepConnectorClasses.line)] = {
                borderColor: '#52C41A',
                borderWidth: 1,
                borderLeftStyle: 'solid',
                height: '24px'
            },
            _c),
        _a["& .".concat(stepConnectorClasses.line)] = {
            borderLeftStyle: 'dashed'
        },
        _a;
});
var QontoStepIconRoot = styled('div')(function (_ref2) {
    var theme = _ref2.theme, ownerState = _ref2.ownerState;
    return _objectSpread(_objectSpread({
        color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center'
    }, ownerState.active && {
        color: '#784af4'
    }), {}, {
        '& .QontoStepIcon-completedIcon': {
            color: '#784af4',
            zIndex: 1,
            fontSize: 18
        },
        '& .QontoStepIcon-circle': {
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: 'currentColor'
        }
    });
});
function QontoStepIcon(props) {
    var active = props.active, completed = props.completed, className = props.className;
    return /*#__PURE__*/ React.createElement(QontoStepIconRoot, {
        id: active ? 'current-state-icon' : 'other-state-icon',
        ownerState: {
            active: active
        },
        className: className
    }, /*#__PURE__*/ React.createElement("img", {
        height: 24,
        width: 24,
        src: active ? StepIconActive : completed ? StepIconComplete : StepIconInActive
    }));
}
var JobCardProgressStepper = function (props) {
    var onClickCloseIcon = props.onClickCloseIcon, steps = props.steps;
    return /*#__PURE__*/ React.createElement(MuiStack, {
        height: '100%',
        padding: 2,
        sx: {
            borderRadius: '8px'
        },
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(IconButton, {
        sx: {
            padding: 0
        },
        onClick: onClickCloseIcon
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "close-stepper-icon",
        id: "close-stepper-button",
        src: CrossIcon
    }))), (steps === null || steps === void 0 ? void 0 : steps.length) > 0 ? /*#__PURE__*/ React.createElement(Stepper, {
        connector: /*#__PURE__*/ React.createElement(QontoConnector, null),
        orientation: "vertical"
    }, steps.map(function (item, index) {
        var labelProps = {};
        if (item.isCompleted || item.isActive) {
            labelProps.optional = /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6",
                color: "#6A7682",
                sx: {
                    paddingTop: 0.5,
                    position: 'absolute'
                },
                id: "stepper-date-time"
            }, item.DateTime ? "".concat(moment(item.DateTime).format('DD MMM, YYYY hh:mm A'), " ") : "");
        }
        return /*#__PURE__*/ React.createElement(Step, {
            key: index,
            active: item.isActive,
            completed: item.isCompleted
        }, /*#__PURE__*/ React.createElement(StepLabel, _extends({
            sx: {
                alignItems: item.isCompleted ? 'flex-start' : 'center',
                "& .MuiStepLabel-labelContainer": {
                    marginTop: item.isCompleted ? '-5px' : 'none'
                }
            }
        }, labelProps, {
            StepIconComponent: QontoStepIcon
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            spacing: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                border: "1px solid ".concat(item.isCompleted ? '#AFD5FF' : '#DEE4EB'),
                backgroundColor: item.isCompleted ? '#EEF6FF' : '#F4F7FA',
                borderRadius: "8px",
                padding: "4px 8px",
                width: 'fit-content'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "statusKeyId",
            variant: "h4",
            color: item.isCompleted ? '#3697FF' : item.isActive ? '#000000' : '#C3CCD6'
        }, item.label)))));
    })) : /*#__PURE__*/ React.createElement(MuiStack, {
        height: '100%',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(NoRowsOverlay, null)));
};
export default JobCardProgressStepper;
